import { render, staticRenderFns } from "./generalError.vue?vue&type=template&id=21d5277f&scoped=true&"
import script from "./generalError.vue?vue&type=script&lang=js&"
export * from "./generalError.vue?vue&type=script&lang=js&"
import style0 from "./generalError.vue?vue&type=style&index=0&id=21d5277f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5277f",
  null
  
)

export default component.exports